import React from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";

interface ActionConfirmationProps {
    actionPhrase: string;
    ticketPhrase: string;
    ticketId: number;
    open: boolean;
    onClose: () => void;
    webBaseUrl: string; // e.g., "https://helpdesk.example.com/tickets/"
}

const ActionConfirmation: React.FC<ActionConfirmationProps> = ({
    ticketId,
    open,
    onClose,
    webBaseUrl,
    actionPhrase,
    ticketPhrase,
}) => {
    const ticketUrl = `${webBaseUrl}calls/callhistory.aspx?call_id=${ticketId}&from=teams`;

    return (
        <Dialog title={`${actionPhrase} Added Successfully`} onClose={onClose}  >
            <div>
                {actionPhrase}  has been added to {ticketPhrase} <a className="nav-link" href={ticketUrl} target="_blank" rel="noopener noreferrer">{ticketId}</a>
            </div>
            <DialogActionsBar>
                <Button themeColor="primary" onClick={onClose}>
                    OK
                </Button>
            </DialogActionsBar>
        </Dialog>
    );
};

export default ActionConfirmation;